export const aboutData = {
  brandName: '布丁漫画',
  tagline: '下拉式看漫画，一气呵成不卡顿',
  founded: '2019',
  story: `布丁漫画诞生于2019年，由一群热爱漫画的年轻人创立。在移动互联网时代，传统的翻页式漫画阅读体验已经无法满足当代读者的需求。我们敏锐地发现，越来越多的读者希望能够像刷社交媒体一样流畅地阅读漫画——不需要等待翻页，不需要忍受加载卡顿。

基于这一洞察，布丁漫画团队历时一年研发了自有的"无缝下拉式阅读引擎"，彻底改变了漫画的阅读方式。每一页漫画之间无缝衔接，读者只需要轻轻向下滑动，内容便会自动加载呈现，真正做到"一气呵成"的沉浸式阅读体验。

从最初只有几百部漫画资源，到如今拥有超过3000部韩漫、国漫、日漫正版内容，布丁漫画始终坚持以用户体验为核心。我们与国内外多家知名漫画平台和独立作者建立了深度合作关系，确保内容持续更新、品类更加丰富。`,
  values: [
    {
      title: '极致体验',
      description: '下拉式无缝阅读，告别翻页等待。每一秒的流畅，都是我们对技术的追求。',
      icon: 'ri-speed-up-line',
    },
    {
      title: '正版内容',
      description: '坚持正版授权，让每一位创作者都能获得应有的回报。',
      icon: 'ri-shield-check-line',
    },
    {
      title: '每日更新',
      description: '与全球同步更新，让你永远第一时间读到最新话。',
      icon: 'ri-refresh-line',
    },
    {
      title: '免费阅读',
      description: '海量漫画免费看，让好故事不再有门槛。',
      icon: 'ri-heart-line',
    },
  ],
  milestones: [
    { year: '2019', event: '布丁漫画正式上线，首创下拉式阅读模式' },
    { year: '2020', event: '漫画库突破1000部，月活用户突破100万' },
    { year: '2021', event: '与韩国三大漫画平台达成战略合作，韩漫资源全面引入' },
    { year: '2022', event: '国漫频道正式上线，与中国知名漫画家签约合作' },
    { year: '2023', event: '日漫频道上线，完成三大漫画品类全覆盖，月活突破500万' },
    { year: '2024', event: '推出AI智能推荐系统，个性化推荐准确率提升60%' },
    { year: '2025', event: '漫画库突破3000部，累计阅读量突破50亿次' },
    { year: '2026', event: '全新改版升级，阅读体验再进化，新增社区互动功能' },
  ],
  testimonials: [
    {
      name: '小雨',
      avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20soft%20portrait%20of%20young%20Asian%20woman%2C%20simple%20clean%20background%2C%20natural%20warm%20lighting%2C%20friendly%20expression%2C%20editorial%20style%2C%20minimal%20aesthetic&width=100&height=100&seq=avatar-01&orientation=squarish',
      content: '布丁漫画的下拉式阅读真的太爽了！以前看漫画翻页翻得手酸，现在只要轻轻一滑就能一直看下去，完全停不下来。而且更新速度也很快，我追的几部韩漫都是第一时间更新。',
      rating: 5,
    },
    {
      name: '星辰大海',
      avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20soft%20portrait%20of%20young%20Asian%20man%2C%20simple%20clean%20background%2C%20natural%20warm%20lighting%2C%20gentle%20expression%2C%20editorial%20style%2C%20minimal%20aesthetic&width=100&height=100&seq=avatar-02&orientation=squarish',
      content: '作为一个看了十几年漫画的老读者，布丁漫画确实是我用过最舒服的漫画阅读平台。界面干净、没有乱七八糟的广告，最重要的是下拉式阅读体验真的做到了极致流畅。',
      rating: 5,
    },
    {
      name: '樱花下的猫',
      avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20soft%20portrait%20of%20young%20Asian%20woman%20with%20glasses%2C%20simple%20clean%20background%2C%20natural%20warm%20lighting%2C%20cheerful%20expression%2C%20editorial%20style%2C%20minimal%20aesthetic&width=100&height=100&seq=avatar-03&orientation=squarish',
      content: '国漫频道的内容越来越丰富了！从《斗罗大陆》到《全职高手》，我想看的几乎都有。而且分类特别细致，找漫画很方便。推荐给所有喜欢看漫画的朋友！',
      rating: 5,
    },
    {
      name: '木叶忍者',
      avatar: 'https://readdy.ai/api/search-image?query=Warm%20toned%20soft%20portrait%20of%20young%20Asian%20man%20with%20dark%20hair%2C%20simple%20clean%20background%2C%20natural%20warm%20lighting%2C%20relaxed%20expression%2C%20editorial%20style%2C%20minimal%20aesthetic&width=100&height=100&seq=avatar-04&orientation=squarish',
      content: '之前一直用别的平台看漫画，自从朋友推荐了布丁漫画就再也回不去了。下拉式阅读简直是降维打击，而且日漫资源也很全，鬼灭、咒术这些热门都有。',
      rating: 4,
    },
  ],
  contact: {
    email: 'contact@budingmanhua.com',
    wechat: '布丁漫画官方',
    weibo: '@布丁漫画',
    address: '北京市朝阳区望京SOHO T3-A座 2501室',
    phone: '400-888-6666',
    workHours: '周一至周五 9:00 - 18:00',
  },
  stats: [
    { label: '漫画总量', value: '3,000+', icon: 'ri-book-open-line' },
    { label: '月活用户', value: '500万+', icon: 'ri-user-line' },
    { label: '累计阅读', value: '50亿+', icon: 'ri-eye-line' },
    { label: '合作作者', value: '800+', icon: 'ri-team-line' },
  ],
};